<template>
  <div v-if="customerNumbers.length > 0">
    <MDBRow v-for="(data, index) in customerNumbers" :key="index">
      <MDBCol col="12" md="6">
        <select
          class="form-select mb-1"
          aria-label=".form-select-lg example"
          v-model="data.wholesaler_id"
          @change="clearFieldErrors(index)"
        >
          <option :value="null" disabled>
            {{ $t('account.profile.selectWholeSaler') }}
          </option>
          <option v-for="(wholesaler, index) in allWholesalers" :key="index" :value="wholesaler.id">
            {{ wholesaler.name }}
          </option>
        </select>
      </MDBCol>
      <MDBCol col="12" md="6">
        <input
          v-model="data.customer_number"
          :disabled="!data.wholesaler_id"
          type="text"
          min="1"
          class="form-control"
          :placeholder="`${$t('account.profile.clientNrSingular')}`"
          :aria-label="`${$t('account.profile.clientNrSingular')}`"
          aria-describedby="basic-addon1"
          @input="clearFieldErrors(index)"
        />
        <div class="text-danger text-small pt-1" v-if="lengthErrors[index]">
          {{ lengthErrors[index] }}
        </div>
        <div class="text-danger text-small pt-1" v-if="existsErrors[index]">
          {{ $t('toast.customerNumberExist') }}
        </div>
      </MDBCol>
      <!-- <MDBCol col="12" md="6">
        <input v-model="data.expected_name" type="text" class="form-control" :placeholder="`${$t(
          'account.profile.selectWholeSaler'
        )}`" :aria-label="`${$t(
          'account.profile.selectWholeSaler'
        )}`" aria-describedby="basic-addon1" />
      </MDBCol> -->
      <!-- <MDBCol col="12" md="3">
        <MDBBtn @click="saveCustomerNumber(data)" type="button" color="danger"
          class="d-flex justify-content-center align-items-center"
          :disabled="!data.customer_number || !data.expected_name"><span>{{ $t("global.buttons.send") }}</span>
        </MDBBtn>
      </MDBCol> -->
    </MDBRow>
  </div>

  <MDBRow>
    <MDBCol col="12" md="6">
      <div class="pt-2">
        <div class="text-uppercase label cursor--pointer" @click="addNewNumberFields()">
          <img :src="require('@/assets/img/plus_btn_small.svg')" alt="logo" />
          <span class="ps-2">{{ $t('account.profile.addAnotherCsNumber') }}</span>
        </div>
      </div>
    </MDBCol>
  </MDBRow>

  <MDBModal v-model="modal" tabindex="-1" centered size="xl" @hide="hideModal">
    <ConfirmCsNumber :data="csNumberData" @close="(e) => hideModal()" />
  </MDBModal>
</template>

<script setup>
import { MDBRow, MDBCol, MDBModal } from "mdb-vue-ui-kit";

import { useStore } from "vuex";
import { computed, defineExpose, ref } from "vue";
import ConfirmCsNumber from "@/components/User/ProfileForms/ConfirmCsNumber.vue";

const store = useStore();
const allWholesalers = computed(() => store.getters.getAllWholesalers);

let customerNumbers = ref([{
  customer_number: "",
  wholesaler_id: null,
  expected_name: null
}]);
const modal = ref(false);
const csNumberData = ref(null);
const existsErrors = ref({});
const lengthErrors = ref({});

const hideModal = () => {
  modal.value = false;
};

const clearExistsError = (index) => {
  if (!existsErrors.value[index]) {
    return;
  }

  const next = { ...existsErrors.value };
  delete next[index];
  existsErrors.value = next;
};

const clearLengthError = (index) => {
  if (!lengthErrors.value[index]) {
    return;
  }

  const next = { ...lengthErrors.value };
  delete next[index];
  lengthErrors.value = next;
};

const clearFieldErrors = (index) => {
  clearExistsError(index);
  clearLengthError(index);
};

const setExistsError = (index) => {
  existsErrors.value = { ...existsErrors.value, [index]: true };
};

const setLengthError = (index, message) => {
  lengthErrors.value = { ...lengthErrors.value, [index]: message };
};

const clearExistsErrors = () => {
  existsErrors.value = {};
};

const clearLengthErrors = () => {
  lengthErrors.value = {};
};

const getCustomerNumbers = () => {
  return Array.isArray(customerNumbers.value) ? customerNumbers.value : [];
};

const addNewNumberFields = () => {
  customerNumbers.value.push({
    customer_number: "",
    wholesaler_id: null,
    expected_name: null
  });
};

const resetCustomerNumbers = () => {
  customerNumbers.value = [{
    customer_number: "",
    wholesaler_id: null,
    expected_name: null
  }];
};

// const saveCustomerNumber = async (payload) => {
//   csNumberData.value = {
//     expected_name: payload.expected_name,
//     customer_number: payload.customer_number,
//     dealer_id: me.value.plainId,
//     id: payload?.id ?? null,
//   };
//   modal.value = true;
// };

defineExpose({
  customerNumbers,
  getCustomerNumbers,
  resetCustomerNumbers,
  setExistsError,
  setLengthError,
  clearExistsErrors,
  clearLengthErrors,
});
</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";

#client-nr {
  padding: 9px 18px 9px 9px;
  background: $secondaryGray;

  h5 {
    margin-bottom: 30px;
  }
}
</style>
